module.exports = __webpack_public_path__ + "img/7-sdg-full@2x.3e47e65a.png";